import { PayloadAction, createSlice } from '@reduxjs/toolkit';

enum ReportStatus {
  'DRAFT' = 0,
  'CLOSED',
}

export interface InformedIndividualItemResponseInterface {
  id: number;
  report: string;
  name: string;
  associated_department: number;
  notification_reason: string;
  date_informed_at: string | null;
  is_deleted: boolean;
  has_error?: boolean;
}

export interface FinalReportItemInterface {
  status: number;
  has_informed_individuals: boolean;
  informed_individuals: Array<InformedIndividualItemResponseInterface>;
}

export interface FinalReportState {
  item: FinalReportItemInterface;
}

const initialState: FinalReportState = {
  item: {
    status: ReportStatus.DRAFT,
    has_informed_individuals: false,
    informed_individuals: [],
  },
};

export const finalReportSlice = createSlice({
  name: 'finalReport',
  initialState,
  reducers: {
    setItem: (state, action: PayloadAction<FinalReportItemInterface>) => {
      state.item = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setItem } = finalReportSlice.actions;

export default finalReportSlice.reducer;
